__turbopack_context__.v({
  "accessibilityMenu": "YBVESa_accessibilityMenu",
  "label": "YBVESa_label",
  "link": "YBVESa_link",
});
